import { render, staticRenderFns } from "./ATouristsProfile.vue?vue&type=template&id=560b3878&"
import script from "./ATouristsProfile.vue?vue&type=script&lang=js&"
export * from "./ATouristsProfile.vue?vue&type=script&lang=js&"
import style0 from "./ATouristsProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports